var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB7\xA8\xEC\x86\x8C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M22.75 5.25L5.25 22.75",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M22.75 22.75L5.25 5.25",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.bfb17f8ab1ad4b281a2cded9e7e87eb1.svg";
export { ForwardRef as ReactComponent };